module.exports = __webpack_public_path__ + "static/media/category.871aa61d.svg";